__turbopack_context__.v({
  "container": "SalesStartSoonPanel-module-scss-module__JJyfEq__container",
  "content": "SalesStartSoonPanel-module-scss-module__JJyfEq__content",
  "ctaButtonWrapper": "SalesStartSoonPanel-module-scss-module__JJyfEq__ctaButtonWrapper",
  "detailsLoadingSkeleton": "SalesStartSoonPanel-module-scss-module__JJyfEq__detailsLoadingSkeleton",
  "earlyAccessContent": "SalesStartSoonPanel-module-scss-module__JJyfEq__earlyAccessContent",
  "earlyAccessDate": "SalesStartSoonPanel-module-scss-module__JJyfEq__earlyAccessDate",
  "earlyAccessLabel": "SalesStartSoonPanel-module-scss-module__JJyfEq__earlyAccessLabel",
  "label": "SalesStartSoonPanel-module-scss-module__JJyfEq__label",
});
